<div class="progress-card mw-100 h-100 bg-white rounded-md shadow-sm-darker overflow-hidden d-flex flex-column">
  <a [routerLink]="url" [queryParams]="queryParam">
    <img src="{{module.imageUrl}}" alt="Banner image for {{this.title}}" class="progress-card__image w-100 bg-black-100 object-cover object-center">
  </a>
  <div class="p-3 d-flex flex-fill flex-column justify-content-between border-top">
    <div class="d-flex flex-fill justify-content-between position-relative">
      <a [routerLink]="url" [queryParams]="queryParam" class="progress-card__text group-link d-block flex-fill align-self-start overflow-auto">
        <h3 class="text-sm font-weight-400 text-primary-darker mb-0">{{this.title}}</h3>
        <p class="text-xs m-0">{{module.courseCode}}</p>
      </a>
      <button *ngIf="hasMenu" data-toggle="dropdown" aria-expanded="false" class="align-self-start bg-white border-0 rounded ml-2 p-2 transition" title="Menu">
        <svg width="3" height="14" viewBox="0 0 3 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.0561523 7.00781C0.0561523 6.82552 0.0926107 6.65365 0.165527 6.49219C0.233236 6.32552 0.326986 6.18229 0.446777 6.0625C0.566569 5.94271 0.709798 5.84896 0.876465 5.78125C1.03792 5.70833 1.2098 5.67188 1.39209 5.67188C1.57438 5.67188 1.74626 5.70833 1.90771 5.78125C2.06917 5.84896 2.2124 5.94271 2.3374 6.0625C2.45719 6.18229 2.55355 6.32552 2.62646 6.49219C2.69417 6.65365 2.72803 6.82552 2.72803 7.00781C2.72803 7.1901 2.69417 7.36198 2.62646 7.52344C2.55355 7.6849 2.45719 7.82813 2.3374 7.95313C2.2124 8.07292 2.06917 8.16927 1.90771 8.24219C1.74626 8.3099 1.57438 8.34375 1.39209 8.34375C1.2098 8.34375 1.03792 8.3099 0.876465 8.24219C0.709798 8.16927 0.566569 8.07292 0.446777 7.95313C0.326986 7.82813 0.233236 7.6849 0.165527 7.52344C0.0926107 7.36198 0.0561523 7.1901 0.0561523 7.00781ZM0.0561523 12.3438C0.0561523 12.1563 0.0926107 11.9818 0.165527 11.8203C0.233236 11.6589 0.326986 11.5182 0.446777 11.3984C0.566569 11.2786 0.707194 11.1849 0.868652 11.1172C1.03011 11.0443 1.20459 11.0078 1.39209 11.0078C1.57959 11.0078 1.75407 11.0443 1.91553 11.1172C2.07699 11.1849 2.21761 11.2786 2.3374 11.3984C2.45719 11.5182 2.55355 11.6589 2.62646 11.8203C2.69417 11.9818 2.72803 12.1563 2.72803 12.3438C2.72803 12.526 2.69417 12.6979 2.62646 12.8594C2.55355 13.0208 2.45719 13.1615 2.3374 13.2813C2.2124 13.401 2.06917 13.4974 1.90771 13.5703C1.74626 13.638 1.57438 13.6719 1.39209 13.6719C1.2098 13.6719 1.03792 13.638 0.876465 13.5703C0.709798 13.4974 0.566569 13.401 0.446777 13.2813C0.326986 13.1615 0.233236 13.0208 0.165527 12.8594C0.0926107 12.6979 0.0561523 12.526 0.0561523 12.3438ZM0.0561523 1.67188C0.0561523 1.48958 0.0926107 1.31771 0.165527 1.15625C0.233236 0.994792 0.326986 0.854167 0.446777 0.734375C0.566569 0.614583 0.709798 0.520833 0.876465 0.453125C1.03792 0.380208 1.2098 0.34375 1.39209 0.34375C1.57438 0.34375 1.74626 0.380208 1.90771 0.453125C2.06917 0.520833 2.2124 0.614583 2.3374 0.734375C2.45719 0.854167 2.55355 0.994792 2.62646 1.15625C2.69417 1.31771 2.72803 1.48958 2.72803 1.67188C2.72803 1.85938 2.69417 2.03385 2.62646 2.19531C2.55355 2.35677 2.45719 2.4974 2.3374 2.61719C2.21761 2.73698 2.07699 2.83333 1.91553 2.90625C1.75407 2.97396 1.57959 3.00781 1.39209 3.00781C1.20459 3.00781 1.03011 2.97396 0.868652 2.90625C0.707194 2.83333 0.566569 2.73698 0.446777 2.61719C0.326986 2.4974 0.233236 2.35677 0.165527 2.19531C0.0926107 2.03385 0.0561523 1.85938 0.0561523 1.67188Z" fill="#616161"/>
        </svg>
      </button>
      <div class="progress-card__menu dropdown-menu dropdown-menu-right bg-white shadow-sm-darker rounded">
        <button *ngIf="type == 'course'" [routerLink]="'/user/forum'" [queryParams]="{'moduleid': module.id}" class="progress-card__menu__button" title="Forum">
          <i class="fa fa-comments"></i>
        </button>
        <!-- <button *ngIf="type == 'course'" class="progress-card__menu__button" title="Live Video" [disabled]="!hasliveclass">
          <a *ngIf="hasliveclass" href="{{livemeetinglink}}" target="_blank"><i class="fas fa-headset"></i></a>
          <i *ngIf="!hasliveclass" class="fas fa-headset text-muted"></i>
        </button> -->
        <button data-toggle="modal" [attr.data-target]="modaltargetId" class="progress-card__menu__button" title="About {{this.typeString}}">
          <i class="fas fa-exclamation-circle"></i>
        </button>
        <button *ngIf="inPackage && currentUserIsAdmin" class="progress-card__menu__button" title="Delete" (click)="deleteButtonClicked()">
          <i class="fas fa-times text-danger"></i>
        </button>
      </div>
    </div>
    <p class="text-xs m-0"*ngIf="module.nextBatchDate"><b>Next Batch:</b> {{this.util.formatDate(module.nextBatchDate)}}</p>
    <p *ngIf="!this.school.hideFeesForFreeCourses || this.price" class="text-xs mt-2 mb-0">{{this.contentCount}} <span class="text-capitalize">{{this.contentTypeString}}</span><br><span class="font-weight-600 text-md">{{this.price ? '₦' + this.formatNumber(this.price) : 'Free'}}</span><ng-template [ngIf]="this.price || this.accessDays"> for <span class="font-weight-600 text-md">{{this.accessDays || 'Unlimited'}}</span> Day{{this.accessDays !== 1 ? 's' : ''}}</ng-template></p>
    
    <div *ngIf="moduleDetails?.moduleinfo?.virtualInstructor">      
      <i class="fa fa-calendar"></i>
      <span *ngIf="moduleDetails.moduleinfo.startDate; else noDate">
        Starts {{ moduleDetails.moduleinfo.startDate | date:'EEE, MMM d, y' }}
      </span>
    
      <ng-template #noDate>
        <span>Ongoing</span>
      </ng-template>
    </div>
    <div class="progress-card__progress-bar bg-black-100 mt-3 rounded" *ngIf="module.progressSet">
      <div class="linear-gradient-primary mw-100 h-100 rounded" [style]="'width: ' + module.progress + '%'"></div>
    </div>
    <a *ngIf="!useraccessservice.loggedIn()"
       [routerLink]="['/access/register']"
       [queryParams]="{ goto: '/user/moduledetails?moduleID=' + module.id }"
       class="mt-2">
      <button class="btn btn-primary">
        Enroll now
      </button>
    </a>
    <a *ngIf="useraccessservice.loggedIn() && module.courseTitle && moduleDetails?.moduleinfo?.requireEnrollment && !currentUserIsAdmin && !moduleDetails.isViewerStudent"
      [disabled]="!moduleDetails.moduleinfo.nextBatchDate && moduleDetails.moduleinfo.allowBatches"
       class="mt-2">
      <button class="btn btn-primary" (click)="submitEnroll()">
        Enroll now
      </button>
    </a>
    <a *ngIf="useraccessservice.loggedIn() && module.courseTitle && !currentUserIsAdmin && moduleDetails.isViewerStudent"      
       class="mt-2">
      <button class="btn btn-primary" (click)="gotoCourse()">
        Go to course
      </button>
    </a>
  </div>
</div>

<div *ngIf="hasMenu" class="modal fade" [id]="modalId" tabindex="-1" role="dialog" [attr.aria-labelledby]="modaltargetId" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="{{module.id}}">{{this.title}}</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-4 text-center">
          <img src="{{module.imageUrl}}" alt="Banner image for {{this.title}}" class="mw-100 bg-black-100 rounded shadow-sm-darker">
        </div>
        <div>
          <h3 class="text-capitalize text-center">{{this.typeString}} Description</h3>
          <div [innerHTML]="module.description" class="innerHTML-wrap innerHTML-wrap--center">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn" [routerLink]="url" [queryParams]="queryParam" data-dismiss="modal">Go to {{this.typeString}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="popbatch" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog" style="    max-width: max-content !important;">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Select Batch</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="d-flex justify-content-center mb-3">
          <select class="form-control" [(ngModel)]="selectedBatchId" [ngModelOptions]="{standalone: true}">
            <option selected disabled value="0">Select Batch</option>
            <option *ngFor="let item of moduleBatches" [ngValue]="item.id">
              {{item.name+" | Start Date:"+this.util.formatDate(item.startDate)}}
            </option>
          </select>
        </div>

        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--primary m-0" (click)="enroll()">Submit</button>
          <button type="button" class="btn btn--warning m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-paymentiframe #payment [loadingPayment]="loadingPayment"></app-paymentiframe>
